import * as React from 'react';
export const billingSvg = React.forwardRef(function billingSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.7 3a.65.65 0 1 0 0 1.3h2.65a.65.65 0 0 0 0-1.3H2.7Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 2v7.613a1 1 0 0 0 1.316.948l2.31-.77A4.5 4.5 0 1 0 9 3.256V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2Zm1.4 7.058L7.6 6.99V2a.6.6 0 0 0-.6-.6H2a.6.6 0 0 0-.6.6v7.058ZM7.5 10.6A3.096 3.096 0 0 1 5 9.333l3.316-1.105A1 1 0 0 0 9 7.279V4.786A3.1 3.1 0 0 1 7.5 10.6Z',
    }),
  );
});
billingSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var billing = {
  category: 'icon',
  colorable: true,
  name: 'billing',
  svg: billingSvg,
};
